<!-- eslint-disable prettier/prettier -->
<template>
  <div class="page">
    <div class="page-container">
      <div class="panel-info">
        <a-affix class="affix-title" :target="affixTarget">
          <div class="panel-info-title">
            <h2 :title="record.meetingTitle" class="text-ellipsis text-no-wrap overflow-hidden text-bold v-mr-sm">{{ record.meetingTitle }}</h2>
            <a-space class="v-ml-auto">
              <a-button type="default" icon="rollback" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </a-affix>
        <a-divider />
        <div class="panel-info-section" style="margin-top: 0">
          <div class="panel-info-section-title">
            <a-icon type="caret-right" class="text-primary v-mr-xs" />
            <span class="text-bold">会议基本信息</span>
          </div>
          <table class="table table-plain">
            <tbody>
              <tr>
                <th width="300">会议主题</th>
                <td colspan="3">{{ record.meetingTitle }}</td>
              </tr>
              <tr v-if="record.project">
                <th>项目名称</th>
                <td colspan="3">{{ record.project.name }}</td>
              </tr>
              <tr>
                <th>会议评审时间</th>
                <td>
                  {{ record.meetingStartTime }}
                  <template v-if="record.meetingStartTime">~ {{ record.meetingEndTime }}</template>
                </td>
              </tr>
              <tr>
                <th>会议方式</th>
                <td colspan="3">{{ record.meetingType }}<template v-if="record.meetingType == '视频会议'">（腾讯会议号：{{ record.meetingCode }}）</template></td>
              </tr>
              <tr>
                <th>专家参会清单</th>
                <td colspan="3">
                  <a-tag color="red" v-for="item in record.experts" :key="item.userName">{{ item.realName }}</a-tag>
                </td>
              </tr>
              <tr>
                <th>美丽心灵参会人员</th>
                <td colspan="3">{{ record.otherParticipant }}</td>
              </tr>
              <tr>
                <th valign="top">会议备注</th>
                <td colspan="3">{{ record.meetingRemark }}</td>
              </tr>
              <tr>
                <th valign="top">会议文件</th>
                <td colspan="3">
                  <file-container :files="record.files" :belongId="meetingId" fileSign="PM" v-if="meetingId"></file-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="panel-info-section" v-if="record.votes && record.votes.length">
          <div class="panel-info-section-title flex items-center">
            <a-icon type="caret-right" class="text-primary v-mr-xs" />
            <span class="text-bold">会议投票主题</span>
          </div>
          <table class="table table-plain" :class="{ 'v-mt-sm': index > 0 }" v-for="(item, index) in record.votes" :key="index">
            <tbody>
              <tr>
                <th width="300">投票主题名称</th>
                <td>
                  <b class="text-brown">{{ item.title }}</b>
                </td>
              </tr>
              <tr v-if="item.voteType == 0">
                <th valign="top" v-if="item.voteTime">我的投票</th>
                <th valign="top" v-else>投票选项</th>
                <td>
                  <a-space :size="12">
                    <span v-for="option in item.options" :key="option.optionId">
                      <i class="fa fa-check-square-o v-mr-xs" :class="[option.checked ? 'fa-check-circle-o text-primary' : 'fa-circle-o']" aria-hidden="true"></i>{{ option.content }}
                    </span>
                  </a-space>
                  <div class="v-mt-md" v-if="item.opinion">投票意见：{{ item.opinion }}</div>
                </td>
              </tr>
              <template v-else-if="item.voteType == 1">
                <tr>
                  <th valign="top">投票限制</th>
                  <td>
                    每位专家最多可投
                    <b class="text-indigo">{{ item.maxNum }}</b>
                    张票
                  </td>
                </tr>
                <tr>
                  <th valign="top" v-if="item.voteTime">我的投票</th>
                  <th valign="top" v-else>投票选项</th>
                  <td>
                    <div v-for="(option, index) in item.options" :key="option.optionId" :class="{ 'v-mt-xs': index > 0 }">
                      <i style="width: 16px" class="fa fa-check-square-o v-mr-xs" :class="[option.checked ? 'fa-check-square-o text-primary' : 'fa-square-o']" aria-hidden="true"></i>{{ option.content }}
                    </div>
                    <div class="v-mt-md" v-if="item.opinion">投票意见：{{ item.opinion }}</div>
                  </td>
                </tr>
              </template>
              <tr v-if="item.voteTime">
                <th valign="top">投票时间</th>
                <td>
                  {{ item.voteTime ? item.voteTime.substring(0, 16) : '' }}
                </td>
              </tr>
              <tr v-else>
                <th valign="top">投票状态</th>
                <td>
                  您还没有投票，<span class="text-indigo hover-line" @click="$router.push(`vote?id=${item.meetingId}`)">去投票</span>
                </td>
              </tr>
                    
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMeeting } from '@/api/project/meeting'
export default {
  name: 'MeetingView',
  data() {
    return {
      meetingId: undefined,
      projectId: undefined,
      loading: false,
      record: {},
      voteCheckOptions: [],
      voteCheckResults: [],
      fileList: [],
    }
  },
  methods: {
    init() {
      let { id, pid } = this.$route.query
      if (id) {
        this.meetingId = +id
        this.loadMeeting()
      }
      if (pid) {
        this.projectId = +pid
      }
    },
    loadMeeting() {
      this.loading = true
      getMeeting(this.meetingId)
        .then(({ data }) => {
          if (data.success) {
            let result = data.result
            let { mfiles = [], votes } = result
            votes.forEach(v => {
              v.options.forEach(option => {
                let voteResult = v.results.find(d => option.optionId == d.chooseOptionId && d.voteUsername == this.userinfo.userName)
                option.checked = voteResult ? true : false
                if (voteResult) {
                  v.voteTime = voteResult.updateTime
                  v.opinion = voteResult.opinion
                }
              })
            })
            this.record = result
            this.fileList = mfiles.map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PM',
              ...file,
            }))
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
  created() {
    this.init()
  },
}
</script>
